<template>
  <div class="purse">
    <el-card shadow="never" class="box-card">
      <div slot="header" class="clearfix">
        <p>
          <span style="font-size: 20px; margin-right: 15px">账户余额</span>
          <el-button type="text" @click="onrechargeDetail">充值记录</el-button>
          <el-button type="text" @click="onrechargeDetail">充值记录及开票申请</el-button>
          <el-button type="text" @click="onWidthdrawDetail" v-if="false">提现记录</el-button>
          <el-button type="text" @click="onbuyData" v-if="false">消费记录</el-button>
        </p>
        <div class="Card_food">
          <div class="food_top">￥{{ dataDictList.AccountBalance }}</div>
          <!-- <el-button type="primary" plain @click="onRecharge" v-if="false">充值</el-button>
          <el-button type="primary" plain @click="onRecharge" >充值</el-button>
          <el-button type="success" plain @click="onWidthdraw"  v-if="false">提现</el-button> -->
        </div>
      </div>
      <!-- <div class="text item">
        <ECharts></ECharts>
      </div> -->
    </el-card>
  </div>
</template>
<script>
import { GetView } from '@/api/general-api'
import ECharts from '@/components/Echarts/Echarts.vue'
export default {
    components: {
    ECharts
  },
  data() {
    return {
      dataDictList: {},
      Userlist: [],
      currentRow: {},
      pagination: {
        pageSize: 20,
        currentPage: 1,
        total: 0,
        orderField: 'ID',
        orderType: 'ascend'
      }
    }
  },
  mounted() {
    this.handleSearching()
  },
  methods: {
    onRecharge(){
      this.$router.push('/center/recharge')
    },
    onWidthdraw(){
      this.$router.push('/PersonalCenter/widthdraw')
    },
    onrechargeDetail() {
      this.$router.push('/center/rechargeDetail')
    },
    onWidthdrawDetail() {
      this.$router.push('/PersonalCenter/widthdrawDetail')
    },
    onbuyData() {
      this.$router.push('/PersonalCenter/buyData')
    },
    // buyData
    async handleSearching() {
      const queryParam = {
        Name: 'users',
        Other: 'shopinfo'
      }
      this.currentRow = null
      await GetView(queryParam).then((res) => {
        if (res.success) {
          this.dataDictList = res.data
          console.log('列表数据', this.dataDictList)
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.purse {
  width: 100%;
  .Card_food {
    height: 40px;
    display: flex;
    align-items: center;
    .food_top{
      font-size: 25px;
      margin-right: 10px;
      color: rgb(255, 0, 21);
    }
  }
}
</style>